module.exports = __webpack_public_path__ + "static/img/5.a4fba1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/zh/5.png
// module id = 5kEm
// module chunks = 0